import React, { type PropsWithChildren } from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { fg } from '@atlassian/jira-feature-gating';

const styles = cssMap({
	container: {
		display: 'flex',
		height: '422px',
		width: '600px',
	},
	containerWithTabs: {
		display: 'flex',
		width: '600px',
	},
});

export const FilterPopupContainer = ({
	children,
	isModeSwitcherEnabled = false,
}: PropsWithChildren<{ isModeSwitcherEnabled?: boolean }>) => (
	<Box
		xcss={
			isModeSwitcherEnabled && fg('list_lovability_improving_filters')
				? styles.containerWithTabs
				: styles.container
		}
	>
		{children}
	</Box>
);
